import React from 'react';
import PropTypes from 'prop-types';
import { waFetch, responseAsJson } from 'wa.admin-ui.fetch';

import MacrosSection from './components/macros-section';
import Loader from '../../loader';
import LocalizationConsumer from '../../../l10n/localization-context';


import './insert-macros.less';

class InsertMacros extends React.Component
{
  static propTypes =
  {
    macros: PropTypes.arrayOf(PropTypes.shape({})),
    endpoint: PropTypes.string.isRequired,
    onMacrosChange: PropTypes.func.isRequired,
    checkedMacros: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  static defaultProps = {
    macros: []
  };

  static getDerivedStateFromProps(props, state)
  {
    const { macros: data } = props;
    return {
      ...state,
      isLoading: !(data && data.length > 0),
      data
    };
  };

  state =
  {
    isLoading: true,
    isLoadError: false,
    data: []
  };

  componentDidMount()
  {
    const { data } = this.state;

    if (data && data.length > 0)
    {
      return;
    }

    this.loadMacros();
  }

  loadMacros = () =>
  {
    const { endpoint } = this.props;

    waFetch(endpoint, { method: 'POST' })
      .then(responseAsJson)
      .then((payload) => {
        this.setState(
          {
            isLoading: false,
            data: payload.editorMacrosModel
          });
      })
      .catch(() => {
        this.setState({isLoadError: true, isLoading: false});
      });
  };

  renderContent = (data) =>
  {
    const { checkedMacros, onMacrosChange } = this.props;

    return (
      <div className="-wa-edit-controls__macros-container">
        <table cellSpacing={0} className="-wa-edit-controls__macros-table">
          <tbody>
            {
              data.map(section => (
                <MacrosSection
                  key={section.title}
                  section={section}
                  checkedMacros={checkedMacros}
                  onMacrosChange={onMacrosChange}
                />)
              )
            }
          </tbody>
        </table>
      </div>
    );
  };

  render()
  {
    const { isLoadError, isLoading, data } = this.state;


    if (isLoading)
    {
      return <Loader className="-wa-edit-controls__macros-loader" />;
    }

    if (isLoadError || !data.length)
    {
      return (
        <div>
          <LocalizationConsumer id="insert-macros-dialog.fetch-error" />
        </div>
      );
    }

    return this.renderContent(data);
  }
}

export default InsertMacros;